import React, { useState } from 'react';
import Icon from '../../../../../../../muiComponents/Icon';
import useTranslate from '../../../../../../../customHooks/useTranslate';
import {
    useZitoneoServices,
    useZitoneoServicesStats,
} from '../../../../../contexts/ZitoneoContentContext';
import IconButton from '../../../../../../../muiComponents/IconButton';

const GeneralAttributesMissing = () => {
    const translate = useTranslate();
    const {
        idVisibleServicesDetail,
        handleVisibleServicesDetail,
        handleFocusHotelService,
    } = useZitoneoServices();
    const {
        totalAttributeDefinitionsInCategory,
        totalFilledAttributeFilledInCategory,
        servicesInCategory,
    } = useZitoneoServicesStats();
    const [isDetailVisible, setIsDetailVisible] = useState(false);

    const serviceTypeCounters: Record<number, number> = {};
    const instanceNumberByHotelServiceId = servicesInCategory.reduce<
        Record<string, number>
    >((acc, service) => {
        serviceTypeCounters[service.IdServiceType] =
            (serviceTypeCounters[service.IdServiceType] || 0) + 1;
        acc[service.Id] = serviceTypeCounters[service.IdServiceType];

        return acc;
    }, {});

    const missingByService = servicesInCategory.reduce<
        {
            IdHotelService: string;
            IdServiceType: number;
            ServiceType: string;
            InstanceName: string;
            definitions: string[];
        }[]
    >((acc, service) => {
        const missingDefinitions = (service.AttributeDefinitions || []).filter(
            definition => {
                const matchingValues = (service.AttributeValues || []).filter(
                    attributeValue =>
                        attributeValue.IdAttributeDefinition ===
                            definition.IdAttributeDefinition &&
                        !attributeValue.Deleted
                );

                const hasFilledValue = matchingValues.some(attributeValue => {
                    return (
                        attributeValue.Value !== null &&
                        attributeValue.Value !== undefined &&
                        attributeValue.Value !== ''
                    );
                });

                return !hasFilledValue;
            }
        );

        if (!missingDefinitions.length) {
            return acc;
        }

        acc.push({
            IdHotelService: service.Id,
            IdServiceType: service.IdServiceType,
            ServiceType: service.ServiceType,
            InstanceName: service.Name || '',
            definitions: missingDefinitions.map(definition => definition.Name),
        });

        return acc;
    }, []);

    if (!totalAttributeDefinitionsInCategory) {
        return null;
    }

    const missingAttributes =
        totalAttributeDefinitionsInCategory -
        totalFilledAttributeFilledInCategory;

    if (!missingAttributes) {
        return (
            <li className='sidebar__quality_signal__item'>
                <div className='quality_signal__item__title'>
                    <Icon
                        iconName='Check'
                        style={{ color: 'var(--primary-400)' }}
                    />
                    <p>{translate('filled_attributes')}</p>
                </div>
                <div className='quality_signal__item__value --completed'>
                    {totalFilledAttributeFilledInCategory} /{' '}
                    {totalAttributeDefinitionsInCategory}
                </div>
            </li>
        );
    }

    return (
        <li className='sidebar__quality_signal__item --with-detail'>
            <div className='sidebar__quality_signal__item__header'>
                <div className='quality_signal__item__title'>
                    <Icon
                        iconName='FormatListBulleted'
                        className='quality_signal__item__icon'
                    />
                    <p>{translate('general_attributes_missing')}</p>
                </div>
                <div className='flex flex-align-center'>
                    <div className='quality_signal__item__value --error'>
                        {missingAttributes}
                    </div>
                    <IconButton
                        iconName={
                            isDetailVisible ? 'ExpandMore' : 'ChevronRight'
                        }
                        onClick={() => setIsDetailVisible(!isDetailVisible)}
                        size='small'
                    />
                </div>
            </div>
            {isDetailVisible ? (
                <ul className='sidebar__quality_signal__detail-list'>
                    {missingByService.map(service => (
                        <li
                            key={service.IdHotelService}
                            className='sidebar__quality_signal__detail-list__item'
                            role='button'
                            tabIndex={0}
                            onClick={() => {
                                handleFocusHotelService(service.IdHotelService);
                                if (
                                    idVisibleServicesDetail !==
                                    service.IdServiceType
                                ) {
                                    handleVisibleServicesDetail(
                                        service.IdServiceType
                                    );
                                }
                            }}
                            onKeyDown={event => {
                                if (
                                    event.key === 'Enter' ||
                                    event.key === ' '
                                ) {
                                    event.preventDefault();
                                    handleFocusHotelService(
                                        service.IdHotelService
                                    );
                                    if (
                                        idVisibleServicesDetail !==
                                        service.IdServiceType
                                    ) {
                                        handleVisibleServicesDetail(
                                            service.IdServiceType
                                        );
                                    }
                                }
                            }}
                        >
                            <Icon
                                iconName='FiberManualRecord'
                                style={{
                                    color: 'var(--error-700)',
                                    fontSize: '12px',
                                    flexShrink: 0,
                                    marginTop: '4px',
                                }}
                            />
                            <div>
                                <div className='sidebar__quality_signal__detail-list__title'>
                                    {service.ServiceType}
                                    {service.InstanceName
                                        ? ` · ${service.InstanceName}`
                                        : ` · #${
                                              instanceNumberByHotelServiceId[
                                                  service.IdHotelService
                                              ] || 1
                                          }`}
                                </div>
                                <div className='sidebar__quality_signal__detail-list__meta'>
                                    {service.definitions.join(', ')}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : null}
        </li>
    );
};

export default GeneralAttributesMissing;
